import React from 'react';

export const CompanyTableSkeleton: React.FC = () => {
  return (
    <>
      {[...Array(8)].map((_, index) => (
        <div
          key={index}
          className="block md:grid md:grid-cols-12 gap-4 px-4 sm:px-6 py-4 animate-pulse"
        >
          {/* Name Column - col-span-3 */}
          <div className="col-span-12 md:col-span-3 flex items-center space-x-3 mb-3 md:mb-0">
            {/* Avatar skeleton */}
            <div className="w-10 h-10 rounded-full bg-gray-300 dark:bg-gray-700"></div>
            <div className="flex-1">
              {/* Name skeleton */}
              <div className="h-4 bg-gray-300 dark:bg-gray-700 rounded w-3/4 mb-2"></div>
              {/* Created date skeleton */}
              <div className="h-3 bg-gray-200 dark:bg-gray-600 rounded w-1/2"></div>
            </div>
          </div>

          {/* Email Column - col-span-3 */}
          <div className="col-span-12 md:col-span-3 flex items-center mb-2 md:mb-0">
            <div className="h-4 bg-gray-300 dark:bg-gray-700 rounded w-2/3"></div>
          </div>

          {/* Address Column - col-span-3 */}
          <div className="col-span-12 md:col-span-3 flex items-center mb-2 md:mb-0">
            <div className="h-4 bg-gray-300 dark:bg-gray-700 rounded w-full"></div>
          </div>

          {/* Phone Column - col-span-2 */}
          <div className="col-span-12 md:col-span-2 flex items-center mb-2 md:mb-0">
            <div className="h-4 bg-gray-300 dark:bg-gray-700 rounded w-1/2"></div>
          </div>

          {/* Company Column - col-span-1 */}
          <div className="col-span-12 md:col-span-1 flex items-center justify-between">
            <div className="h-4 bg-gray-300 dark:bg-gray-700 rounded w-16"></div>
            {/* Arrow icon skeleton */}
            <div className="w-5 h-5 bg-gray-300 dark:bg-gray-700 rounded"></div>
          </div>
        </div>
      ))}
    </>
  );
};
